export { default as InventoryListTemplate } from './InventoryListTemplate';
export { default as InventorySyncTemplate } from './InventorySyncTemplate';
export { default as InventorySyncListTemplate } from './InventorySyncListTemplate';
export { default as AdjustAllSkusTemplate } from './AdjustAllSkusTemplate';



// WEBPACK FOOTER //
// ./src/themes/default/modules/product-inventory/pages/index.js